module.exports = __webpack_public_path__ + "img/凤凰于飞铭牌.664d3209.png";